module.exports = "<div class=\"f-ctrl\">\n\t<p class=\"f-ctrl__label\">{{ inputLabel }}:</p>\n\t<label class=\"file-upload\" :class=\"inputClass\">\n\t\t<span>{{ message }}</span>\n\t\t<input type=\"file\" :name=\"inputName\" :data-vv-as=\"vvAs\" :multiple=\"multiple\" @change=\"processFiles($event)\" v-validate.reject=\"customValidateString\">\n\t</label>\n\t<span v-show=\"errors.has(inputName)\" class=\"f-ctrl__error\">{{ errors.first(inputName) }}</span>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./assets/_js/components/file-upload/file-upload.vhtml
// module id = 305
// module chunks = 0